import React, {useState} from 'react';
import ReactPaginate from 'react-paginate';
import { ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";

const DEFAULT_PAGE_SIZE_OPTIONS = [1, 2, 5, 25, 50];

const Pagination = (props) => {
  const { pageSize, setPageSize, dataCount, setCurrentPage, currrentPage, pageSizeOptions } =  props.pagination;
  const [dropdownOpen, setOpen] = useState(false);
  const sizeOptions = pageSizeOptions || DEFAULT_PAGE_SIZE_OPTIONS;

  const handlePageSize = (e) => {
    setCurrentPage(1);
    setPageSize(e);
  };

  return (
    <div className="pagination_outer">
    <ButtonDropdown isOpen={dropdownOpen} toggle={() => setOpen(prev => !prev)}>
      <DropdownToggle caret color="primary">
        {pageSize}
      </DropdownToggle>
      <DropdownMenu>
        {sizeOptions.map((size) => (
          <DropdownItem key={size} onClick={() => handlePageSize(size)}>
            {size}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </ButtonDropdown>

    <ReactPaginate
        previousLabel={'‹'}
        nextLabel={'›'}
        breakLabel={'...'}
        breakClassName={'break-me'}
        pageCount={Math.floor((dataCount + pageSize - 1) / pageSize)}
        marginPagesDisplayed={2}
        pageRangeDisplayed={3}
        forcePage={currrentPage - 1}
        onPageChange={e => setCurrentPage(e.selected + 1)}
        containerClassName={'pagination'}
        subContainerClassName={'pages pagination'}
        activeClassName={'active'}
        pageClassName={'page-item'}
        pageLinkClassName={'page-link'}
        previousClassName={"page-item"}
        nextClassName={"page-item"}
        previousLinkClassName={"page-link"}
        nextLinkClassName={"page-link"}
      />

    </div>
  );
};

export default Pagination;